// AI-CONTEXT: See docs/features/participation-ladder.md
import { PAID_WORK_ACTIVITY, INACTIVITY_LEVEL_STEPS } from './participationOptions'

// Maps the current activity to a participatieladder trede (1-6). Paid work
// splits into trede 5 ("met ondersteuning", when not fully employable) and
// trede 6 ("zonder ondersteuning"). "Niet actief" spans the bottom three rungs,
// distinguished by the inactivityLevel sub-question — defaults to the lowest
// rung (Geïsoleerd) until answered. Returns null for an unknown/missing activity.
const deriveParticipationStep = (profile = {}) => {
    const { mainActivity } = profile

    if (mainActivity === PAID_WORK_ACTIVITY) {
        const employability = Number(profile.employabilityFactor)
        return Number.isFinite(employability) && employability < 1 ? 5 : 6
    }

    if (mainActivity === 'Vrijwilligerswerk'
        || mainActivity === 'Dagbesteding'
        || mainActivity === 'Opleiding') return 4
    if (mainActivity === 'Werkzoekend') return 3
    if (mainActivity === 'Niet actief') return INACTIVITY_LEVEL_STEPS[profile.inactivityLevel] || 1

    return null
}

export default deriveParticipationStep
